<template>
  <div class="register">

    <v-layout row justify-center>
      <v-flex xs12 sm6 md6 lg4>
        <v-card class="card-main">
          <v-card-media :src="changeLogo()" :class="changeCssColor()" height="200px" contain>
          </v-card-media>
          <!-- <v-card-media class="backgroud-logo" height="200px">
          </v-card-media> -->
          <v-card-title primary-title>
            <v-card-text>
              <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="headline">Dev</div>
                    <v-alert type="info" :value="bodyData" dismissible >
                      <div class="headline">Usuário já cadastrado</div>
                      <p>Seu usuário já esta cadastrado na nossa base de dados</p>
                      <p>A plataforma <a href="http://www.spitzer.io">Spitzer</a> tem agendamento online em várias clinicas e hospitais</p>
                      <p>Informe seu telefone e seu convênio</p>
                    </v-alert>

                    <v-form v-model="valid" ref="form" lazy-validation>
                      <v-flex xs12 sm12>
                        <v-text-field
                          class="username"
                          @blur="searchEmail()"
                          label="E-Mail/Usuário"
                          v-model="auth.username"
                          :counter="40"
                          :rules="[v => !!v || 'E-mail obrigatório!!']" required
                          prepend-icon="email"
                        ></v-text-field>
                        <v-text-field
                          :disabled="bodyData"
                          label="Nome"
                          v-model="auth.name"
                          :rules="nameRules"
                          :counter="40"
                          required
                          class="name"
                        ></v-text-field>
                        <v-radio-group v-model="auth.gender" row class="gender">
                          <v-radio label="Masculino" value="M" color="blue"></v-radio>
                          <v-radio label="Feminino" value="F" color="red"></v-radio>
                        </v-radio-group>
                        <v-text-field
                          label="CPF"
                          v-model="auth.cpf"
                          :rules="[v => !!v || 'CPf obrigatório!!']" required
                          mask="###.###.###-##"
                          class="cpf"
                          :disabled="bodyData"
                        ></v-text-field>
                        <v-text-field label="Data Nasc."
                          mask="date"
                          v-model="auth.birthDay"
                          :rules="[v => !!v || 'Data de Nasc. obrigatória!!']" required
                          class="birthDay"
                          :disabled="bodyData"
                        ></v-text-field>
                        <v-select
                          class="healthInsurance"
                          ref="healthInsurance"
                          item-text="name"
                          item-value="id"
                          label="Convênio"
                          v-model="auth.healthInsurance"
                          :items="healthInsurances"
                          :rules="[v => !!v || 'Convênio obrigatório!!']" required
                        ></v-select>
                        <div v-if = "this.customer === '5ac6894e806793790864e9db'">
                          <v-text-field
                            class="mobile"
                            label="Fone Fixo"
                            mask="(##) ####-#####"
                            v-model="auth.phone"
                            prepend-icon="phone"
                          ></v-text-field>
                        </div>
                        <v-text-field
                          class="mobile"
                          label="Celular"
                          mask="(##)# ####-####"
                          v-model="auth.mobile"
                          prepend-icon="phone"
                          :rules="[v => !!v || 'Você deve informar um número de celular!']" required
                        ></v-text-field>
                        <v-text-field
                          class="password"
                          ref="password"
                          name="input-10-1"
                          label="Entre com sua senha"
                          hint="Deve conter mais de 6 caracteres"
                          v-model="auth.password"
                          min="6"
                          :rules="passwordRules"
                          :append-icon="p1 ? 'visibility_off' : 'visibility'"
                          :append-icon-cb="() => (p1 = !p1)"
                          :type="p1 ? 'password' : 'text'"
                          counter
                          color="cyan darken"
                          loading
                        >
                          <v-progress-linear v-if="custom" slot="progress" :value="progress" height="8" :color="color"></v-progress-linear>
                        </v-text-field>
                      </v-flex>
                    <div class="buttons">
                      <v-btn
                        color = 'primary'
                        @click="submit"
                        :disabled="!valid"
                      >
                        Cadastrar
                      </v-btn>
                      <router-link to="/patient/login">
                        <v-btn @click="clear">Voltar</v-btn>
                      </router-link>
                    </div>
                  </v-form>
                </v-flex>
              </v-layout>
              </v-container>
            </v-card-text>
          </v-card-title>
          <v-card-actions>
            <div>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar
      :timeout="snackbarConfig.timeout"
      :color="snackbarConfig.color"
      :multi-line="snackbarConfig.mode === 'multi-line'"
      :vertical="snackbarConfig.mode === 'vertical'"
      v-model="snackbarConfig.snackbar"
    >
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'
  import { mapActions, mapGetters } from 'vuex'
  import customersTheme from '../../../config/customersTheme'

  import { CPF } from 'cpf_cnpj'
  // import { setTimeout } from 'timers'

  export default {
    name: 'Register',
    computed: {
      progress () {
        return Math.min(100, this.auth.password.length * 10)
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      },
      ...mapGetters({
        customer: 'customer'
      }),
      ...mapGetters('app', ['getTheme'])
    },
    data: () => ({
      dialogCancel: false,
      bodyData: false,
      birthday: {
        dateFormatted: null,
        menu: false
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de comunicação com o servidor'
      },
      nameRules: [
        (v) => !!v || 'Nome obrigatório!',
        (v) => v.length <= 40 || 'Limite de 40 caracteres'
      ],
      passwordRules: [
        (v) => !!v || 'Senha obrigatória!',
        (v) => v.length <= 20 || 'Limite de 20 caracteres'
      ],
      exists: false,
      e1: 0,
      p1: true,
      custom: true,
      healthInsurances: [],
      valid: true,
      auth: {
        name: '',
        username: '',
        password: '',
        passwordConfirm: '',
        enabled: true,
        customer: this.customer,
        customerName: '',
        type: 'Owner',
        cpf: '',
        birthDay: '',
        healthInsurance: '',
        phone: '',
        mobile: '',
        gender: 'M'
      },
      checkbox: false
    }),
    mounted () {
      // console.log(this.$validator)
      this.loadHealthInsurance()
      // console.log(this.auth.birthDay.substring(0, 2) + '-' + this.auth.birthDay.substring(2, 4) + '-' + this.auth.birthDay.substring(4, 8))
    },
    methods: {
      ...mapActions(['setUser']),
      changeCssColor () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        // console.log(customerTheme.cssClass)
        return customerTheme.cssClass
      },
      changeLogo () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        return customerTheme.logo
      },
      searchEmail () {
        console.log(this.customer)
        this.$http.get(process.env.URL + '/schedule-online/auth/patient/search-user', {
          params: {
            customer: this.customer,
            username: this.auth.username
          }
        }).then((emailUser) => {
          this.dialogCancel = true
          /** Verifica se já existe cadastro neste cliente */
          // const customer = emailUser.data.result[0].scheduleOnline.client.map(item => item.customer)
          // const exists = customer.filter(item => item === this.customer)
          // console.log(exists)
          // if (exists) {
          //   this.snackbarConfig.snackbar = true
          //   this.snackbarConfig.color = 'info'
          //   this.snackbarConfig.text = 'Você já possui cadastro!'
          //   setTimeout(() => {
          //     this.$router.push('/patient/login')
          //   }, 3000)
          // }
          /** *************************************** */

          // this.snackbarConfig.snackbar = true
          // this.snackbarConfig.color = 'info'
          // this.snackbarConfig.text = 'Você já possui cadastro na nossa base de dados! Digite sua senha já cadastrada'

          this.bodyData = true
          this.auth = {
            username: this.auth.username,
            name: emailUser.data.result[0].name,
            password: '',
            enabled: true,
            passwordConfirm: '',
            customer: this.customer,
            customerName: '',
            type: 'Owner',
            cpf: emailUser.data.result[0].profile.cpf,
            birthDay: moment(emailUser.data.result[0].profile.birthDay, 'MM/DD/YYYY').format('DD/MM/YYYY'),
            healthInsurance: '',
            phone: emailUser.data.result[0].profile.phone,
            mobile: emailUser.data.result[0].profile.mobile,
            gender: emailUser.data.result[0].profile.gender
          }
          // this.$refs.healthInsurance.focus()
        }).catch((err) => {
          console.log(err)
        })
      },
      loadHealthInsurance () {
        this.$http.get(process.env.URL + '/schedule-online/health-insurance', {
          params: {
            customer: this.customer
          }
        }).then((healthInsurance) => {
          this.healthInsurances = healthInsurance.data.result
          this.healthInsuranceLoading = true
        }).catch((err) => {
          this.snackbarConfig.snackbar = true
          this.snackbarConfig.color = 'warning'
          this.snackbarConfig.text = 'Erro ao carregar convênios, tente novamente!'
          console.log(err)
        })
      },
      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      parseDate (date) {
        if (!date) {
          return null
        }

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      submit () {
        console.log(this.auth.birthDay)
        this.$validator.validateAll()
        const cpfValid = this.auth.cpf.replace('.', '').replace('-', '')
        if (!CPF.isValid(cpfValid)) {
          this.snackbarConfig.snackbar = true
          this.snackbarConfig.text = 'CPF inválido!'
          return false
        }
        const user = {
          name: this.auth.name,
          username: this.auth.username.trim(),
          password: this.auth.password.trim(),
          enabled: true,
          customer: this.customer,
          customerName: '',
          type: 'Owner',
          healthInsurance: this.auth.healthInsurance,
          cpf: this.auth.cpf,
          birthDay: this.auth.birthDay.substring(2, 4) + '-' + this.auth.birthDay.substring(0, 2) + '-' + this.auth.birthDay.substring(4, 8),
          phone: this.auth.phone,
          mobile: this.auth.mobile,
          gender: this.auth.gender
        }

        if (this.$refs.form.validate()) {
          axios.post(process.env.URL + '/schedule-online/auth/patient/create',
            user
          ).then((result) => {
            this.$router.push('/')
          }).catch((err) => {
            // if (err.response.data.message) {
            //   this.snackbarConfig.snackbar = true
            //   this.snackbarConfig.text = err.response.data.message
            //   return false
            // }
            if (err.response.data.errors) {
              if (err.response.data.errors.birthDay) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.birthDay.msg
                return false
              } else if (err.response.data.errors.name) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.name.msg
                return false
              } else if (err.response.data.errors.username) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.msg
                return false
              } else if (err.response.data.errors.password) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.password.msg
                return false
              } else if (err.response.data.errors.mobile) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.mobile.msg
                return false
              } else {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>

<style scoped>
  /* .register {margin-top: 20px;}   */
  .card-main {margin-top: -20px;}
  .card__title {margin-top: -40px;}
  .usernamename {margin-top: -10px;}
  .name {margin-top: -10px;}
  .gender {margin-top: -20px;}
  .cpf {margin-top: -10px;}
  .birthDay {margin-top: -10px;}
  .healthInsurance {margin-top: -10px;}
  .mobile {margin-top: -10px;}
  .password {margin-top: -10px;}
  .buttons {margin-top: -10px;}
  /* .login {margin-top: 20px;} */
  .logo {
    background-image: url("https://s3-sa-east-1.amazonaws.com/spitzer.io/customers/logos/logo-ipo.png");
  }
  .backgroud-logo {
    background-color: #880E4F;
    /* background-color: #fff; */
  }
</style>



// WEBPACK FOOTER //
// src/views/auth/Register.dev.vue